import "./styles.scss"

import React, { useState } from "react"
import axios from "axios"
import { navigate } from "gatsby"
import { FileUploader } from "react-drag-drop-files"

import { useLocale } from "context/locale"
import { useWindow } from "context/window"

import Input from "components/Input"
import Checkbox from "components/Checkbox"
import Button from "components/Button"
import { UploadIndicator } from "../components"

import { handleFormFiles } from "utils"

import IcoCheck from "assets/icons/check-uploader.svg"
import IcoUpload from "assets/icons/upload-cloud.svg"

const MAX_FILES = 2
const fileTypes = ["PDF", "DOC", "DOCX"]

const CareerForm = ({ position, type }) => {
  const { lang, t } = useLocale()
  const { isBrowser } = useWindow()

  const formID = "8"
  const [send, setSend] = useState(false)
  const [name, setName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [country, setCountry] = useState("")
  const [message, setMessage] = useState("")
  const [legalFirst, setLegalFirst] = useState(false)
  const [files, setFiles] = useState(null)

  const [uploadProgress, setUploadProgress] = useState(null)

  const handleChange = selectedFiles => {
    const formFiles = handleFormFiles(selectedFiles, files, MAX_FILES)

    setFiles(formFiles)
  }

  const location = isBrowser ? window.location.href : null

  const formSubmit = e => {
    e.preventDefault()
    setSend(true)

    let formData = new FormData()

    formData.set("position", position)
    formData.set("firstName", name)
    formData.set("lastName", lastName)
    formData.set("email", email)
    formData.set("phone", phone)
    formData.set("country", country)
    formData.set("message", message)
    formData.set("legalFirst", legalFirst)
    formData.set("pageurl", location)

    if (files) {
      files.forEach((file, index) => {
        if (index === 0) {
          formData.set("file", file)
        } else if (index === 1) {
          formData.set("fileSecond", file)
        }
      })
    }

    axios({
      method: "post",
      url: `https://webinity.zenx.pl/wp-json/contact-form-7/v1/contact-forms/${formID}/feedback/`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: event =>
        setUploadProgress({
          progress: event.progress,
          estimated: event.estimated,
        }),
    })
      .then(res => {
        navigate(t("/contact-confirmation/"))
      })
      .catch(err => {
        console.log(err)
      })
  }

  return (
    <form onSubmit={formSubmit} className="form">
      {type === "single" && (
        <Input
          className={type === "single" ? "input--dark" : ""}
          label={t("Position")}
          type="text"
          id="position"
          name="position"
          value={position}
          required
          disabled
        />
      )}
      <Input
        className={type === "single" ? "input--dark" : ""}
        label={t("Name")}
        placeholder={t("John")}
        type="text"
        id="name"
        name="name"
        value={name}
        onChange={e => setName(e.target.value)}
        required
      />
      <Input
        className={type === "single" ? "input--dark" : ""}
        label={t("Surname")}
        placeholder={t("Doe")}
        type="text"
        id="lastName"
        name="lastName"
        value={lastName}
        onChange={e => setLastName(e.target.value)}
        required
      />
      <Input
        className={type === "single" ? "input--dark" : ""}
        label={t("Email")}
        placeholder={t("john.doe@example.com")}
        type="email"
        id="email"
        name="email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        required
      />
      <Input
        className={type === "single" ? "input--dark" : ""}
        label={t("Phone")}
        placeholder="123-123-123"
        type="tel"
        id="phone"
        name="phone"
        value={phone}
        onChange={e => setPhone(e.target.value)}
        required
      />
      <Input
        className={type === "single" ? "input--dark" : ""}
        label={t("Country")}
        placeholder={lang === "pl" ? "Polska" : "United States of America"}
        type="text"
        id="country"
        name="country"
        value={country}
        onChange={e => setCountry(e.target.value)}
        required
      />
      <Input
        className={type === "single" ? "input--dark" : ""}
        label={t("Message")}
        placeholder={t("Type your message here...")}
        type="textarea"
        id="message"
        name="message"
        value={message}
        onChange={e => setMessage(e.target.value)}
        rows="6"
        required
      />

      <div
        className={`file-uploader${
          type === "single" ? " file-uploader--dark" : ""
        }`}
      >
        <label className="input__label" htmlFor="file-uploader">
          {t("Add files")}
          <span>*</span>
        </label>
        <FileUploader
          id="file-uploader"
          name="file-uploader"
          hoverTitle=""
          multiple={true}
          handleChange={handleChange}
          types={fileTypes}
        >
          <div className="file-uploader__content">
            <img src={IcoUpload} alt="" />
            <span
              dangerouslySetInnerHTML={{
                __html: t(
                  `<span>Click to upload</span> or drag and drop file (max ${MAX_FILES} files)`
                ),
              }}
            />
            <small>
              {t("Acceptable format:")} {fileTypes.join(", ")}.
            </small>
          </div>
        </FileUploader>
      </div>

      {files && (
        <div className="file-uploader__files">
          {files.map(file => (
            <div className="file-uploader__file" key={file.name}>
              <p>
                <img src={IcoCheck} alt="" />
                {t("File")}: {file.name}
              </p>
              <button
                onClick={() =>
                  setFiles(prevFiles =>
                    prevFiles.filter(prevFile => prevFile.name !== file.name)
                  )
                }
              >
                {t("Delete file")}
              </button>
            </div>
          ))}
        </div>
      )}

      <Checkbox
        className={type === "single" ? "checkbox--dark" : ""}
        name="legalFirst"
        checked={legalFirst}
        onChange={() => setLegalFirst(!legalFirst)}
        required
      >
        <span>*</span>
        <div
          dangerouslySetInnerHTML={{
            __html: t(
              "I accept Webinity's <a href='/privacy-policy/'>Privacy Policy</a> and understand that providing the data indicated in the form is voluntary and required to receive an answer to my inquiry."
            ),
          }}
        />
      </Checkbox>

      <p className="form__info">
        <span>*</span> {t("Required field").toLowerCase()}
      </p>

      {uploadProgress && (
        <UploadIndicator
          progress={uploadProgress.progress}
          estimated={uploadProgress.estimated}
        />
      )}

      <div className="form__submit">
        <Button
          className="button--small button--blue"
          type="submit"
          disabled={!legalFirst}
        >
          {send === true ? t("Sending...") : t("Send message")}
        </Button>
      </div>
    </form>
  )
}

export default CareerForm
